'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

exports.default = preload;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global window, document */
function preload(renderer) {
    var pageOptions = window.pageOpts;
    if (!pageOptions) {
        return;
    }

    renderer.setPageOptions(pageOptions);

    var adPlacements = (0, _from2.default)(document.querySelectorAll('.ad'));

    adPlacements.forEach(function (ad) {
        return renderer.register(ad);
    });
}
//# sourceMappingURL=preloader.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ad-renderer/lib/preloader.js
 ** module id = 467
 ** module chunks = 1
 **/